exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* PriorityFilter */\n.prio-chooser-container .prio-chooser {\n  width: 100%;\n  display: flex;\n  padding: 10px; }\n  .prio-chooser-container .prio-chooser label {\n    flex: 1; }\n    .prio-chooser-container .prio-chooser label input {\n      margin-right: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/priority-filter/style.scss
// module id = 1240
// module chunks = 0